/* eslint-disable max-len */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { TopQuestionsWrapper, TopQuestionsHeader, EmptyQuestionsWrapper } from './styled';
import QuestionDomain from './question-domain';
import { getQuestion } from '../../containers/link-upf-modal/link-upf-modal-utils';
import { createPreviewModal } from '../preview-modal/preview-modal';
import { activateModal } from '../../containers/modal-manager/modal-manager-actions';
import InfoTooltip from '../info-tooltip/info-tooltip';
import { TOP_PROBLEM_QUESTIONS_STATUS } from '../../helpers/utils';

const TopProblemQuestions = ({ i18n }) => {
  const dispatch = useDispatch();

  const { questions, topProblemQuestionsStatus } = useSelector(state => state.linkUpfModalReducer);
  const { genericCourses } = useSelector(state => state.UPFAssignReducer);

  if (topProblemQuestionsStatus === TOP_PROBLEM_QUESTIONS_STATUS.NO_SPINE_TAGGING) {
    return (
      <EmptyQuestionsWrapper>
        <p>
          {i18n.t`There are currently no Understanding, Practice and Fluency activities (Quests) to recommend.`}<br />
          {i18n.t`Please check back soon as we are updating recommendations regularly.`}
        </p>
      </EmptyQuestionsWrapper>
    );
  }

  if (topProblemQuestionsStatus === TOP_PROBLEM_QUESTIONS_STATUS.NO_RESULTS) {
    return (
      <EmptyQuestionsWrapper>
        <p>{i18n.t`This feature will recommend Understanding, Practice & Fluency activities (Quests) to support learning gaps identified.`}</p>
        <p>{i18n.t`Recommendations will be made here once the whole group has completed the assessment.`}</p>
        <p>{i18n.t`You can also assign these activities to individual students based on recommendations in the student tab.`}</p>
      </EmptyQuestionsWrapper>
    );
  }

  if (topProblemQuestionsStatus === TOP_PROBLEM_QUESTIONS_STATUS.ALL_CORRECT || !(questions && questions.length)) {
    return (
      <EmptyQuestionsWrapper>
        <p className="no-recommendations">{i18n.t`No recommendations.`}</p>
      </EmptyQuestionsWrapper>
    );
  }

  return (
    <TopQuestionsWrapper>
      <ul>
        <li key="header">
          <TopQuestionsHeader>
            <p className="header-text">{i18n.t`Top Problem Questions`}</p>
            <InfoTooltip>
              {i18n.t`Based on the current`}
              <strong>&nbsp;{i18n.t` assessment type`}</strong>
              {i18n.t`, these questions had the highest frequency of errors for this group of students.`}
            </InfoTooltip>
          </TopQuestionsHeader>
        </li>
        {
          questions && questions.map((question, index) => {
            const girlId = question.girlId;
            const questionNum = getQuestion(girlId, genericCourses).name;
            const percentage = 100 - Number(question.pct);
            const domain = question.domain;
            return index < 5 && (<li className="row" key={girlId}>
              <div className="number">{questionNum}</div>
              <QuestionDomain domainName={domain} />
              <div
                className="view"
                role="button"
                tabIndex="-1"
                onClick={() => {
                  const previewInfo = {
                    domain,
                    question: questionNum,
                    girlId,
                    showBackButtons: true
                  };
                  dispatch(activateModal(createPreviewModal({ previewInfo, i18n })));
                }}
              >
                {i18n.t`View`}
              </div>
              <div className="percentage">
                {percentage}%&nbsp;
                <span role="img" aria-label={i18n.t`incorrect`}>&#10006;</span>
              </div>
            </li>);
          })
        }
      </ul>
    </TopQuestionsWrapper>);
};

TopProblemQuestions.propTypes = {
  i18n: PropTypes.object
};

export default TopProblemQuestions;
